<template lang="pug">
app-text-input(
  v-model="rawValue"
  v-bind="attrs"
  v-on="listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
export default {
  name: 'MaskedInput',
  components: {},
  props: {
    value: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      required: true,
    },
    normalize: {
      type: Function,
      default: (rawValue) => rawValue,
    },
  },
  data() {
    return {
      rawValue: this.value,
    };
  },
  computed: {
    attrs() {
      const { mask } = this.$props;

      return {
        mask,
        placeholder: mask.replace(/[#ANX?]/g, '_'),
        ...this.$attrs,
      };
    },
    listeners() {
      const { input, change, ...rest } = this.$listeners;

      return {
        ...rest,
      };
    },
  },
  watch: {
    value(val) {
      this.rawValue = val;
    },
    rawValue(value) {
      this.$emit('update:raw-value', value);

      const normalizedValue = this.normalize(value);
      this.$emit('input', normalizedValue);
      this.$emit('change', normalizedValue);
    },
  },
  created() {},
  methods: {},
};
</script>
